import AOS from 'aos';

export const animations = () => {
  // document.addEventListener('DOMContentLoaded', () => {
    AOS.init();

    // hard refresh AOS to prevent hidden aos elements when page length changes
    const departmentSelect = document.getElementById('form-input-chooseDepartment');

    if (departmentSelect) {
      setTimeout(() => { AOS.refreshHard(); }, 500)

      departmentSelect.addEventListener('change', () => {
        AOS.refreshHard(true);
      });
    }
  // });
};
